import React from 'react';
import { Link } from 'react-router-dom';

const Top = () => (
	<div className="top-container row">
		<Link to="/" className="top col-lg-8 offset-lg-2 py-4 d-flex flex-wrap align-items-center">
			<div className="col-lg-12 pl-0">
				<img alt="logo" className="logo col-lg-6 col-md-8 col-sm-12 pl-0" src="/images/tand6.png" />
			</div>
			<i className="whisper mb-0 ml-3">En del av Praktikertjänst</i>
			{/*<div className="d-flex flex-column">
				<h1 className="title">Tandläkarhuset Beata Pregiel</h1>
				<p className="whisper mb-0">En del av Praktikertjänst</p>
			</div>*/}
		</Link>
	</div>
);

export default Top;



// WEBPACK FOOTER //
// ./src/components/Top.js